import { translations } from '../../../../../../../locales/translations';
import { BookingUserType } from '../../../../../../../types/BookingType';
import {
  BOOKING_DEPOT_TYPES,
  BOOKING_PACKING_TYPES
} from '../../../../../../../utils/helpers/BookingHelper';
import { ActivityData } from '../../ActivityData';
import { BuilderDecisionParams } from '../../BuilderDecisionParams';
import { EventMessageBuilder } from '../../EventMessageBuilder';
import { useFormatTranslationWithDate } from '../../MainMessageBuilder/useFormatTranslationWithDate';

export const useDropOffDateSetMessageBuilder = (): EventMessageBuilder => {
  const { formatTranslationWithDate } = useFormatTranslationWithDate();

  const supports = ({
    bookingType,
    eventResult: { data, userType }
  }: BuilderDecisionParams): boolean => {
    return (
      userType === BookingUserType.SF &&
      data.startDate !== undefined &&
      (BOOKING_PACKING_TYPES.includes(bookingType) ||
        BOOKING_DEPOT_TYPES.includes(bookingType))
    );
  };

  const build = ({ startDate }: ActivityData): string => {
    return formatTranslationWithDate(
      translations.pages.booking.features.activity.convelioDropOffDateSet,
      startDate
    );
  };

  return {
    build,
    supports
  };
};
